// src/hooks/usePaginasColeta.js
import { useEffect, useMemo, useState } from 'react';
import { useBootstrap } from '../context/BootstrapContext';
import { listarPaginasColeta } from '../infra/api/Coletas';
import { PAGINAS_COLETA, rotuloAlvo, unidadeExibida } from '../utils/coleta';

/**
 * Páginas de coleta configuradas, com o que as telas fora delas precisam para exibir
 * um resultado igual à própria página: `{ [pagina]: { config, meta, unidade, rotuloMedida } }`
 * (unidade completa do protocolo — "UFC/mL" — e o nome da medida — "CBT").
 */
export default function usePaginasColeta() {
    const { bootstrap } = useBootstrap();
    const [configs, setConfigs] = useState(null);

    useEffect(() => {
        let vivo = true;
        listarPaginasColeta()
            .then((lista) => vivo && setConfigs(lista || []))
            .catch(() => vivo && setConfigs([]));
        return () => {
            vivo = false;
        };
    }, []);

    const paginas = useMemo(() => {
        const mapa = {};
        (configs || []).forEach((config) => {
            const meta = PAGINAS_COLETA[config.pagina];
            if (!meta) return;
            const protocolo = (bootstrap?.protocolos || []).find((p) => p.id === config.protocoloId);
            mapa[config.pagina] = {
                config,
                meta,
                unidade: unidadeExibida(protocolo, config.unidade),
                rotuloMedida: rotuloAlvo(config.alvo),
            };
        });
        return mapa;
    }, [configs, bootstrap?.protocolos]);

    return { paginas, carregando: configs === null };
}
